<template>
  <section v-bind:class="getClass()">
    <div v-if="this.$route.params.game === 'overwatch'">
      <img class='overwatch-logo logo-image' src="./../assets/overwatch/logo.png" alt="overwatch-logo">
      <section class='search'>
        <div class='track-player-stats-container'>
          <h1>Track Player Stats</h1>
          <input v-on:click="goBackToMain" type="button" value="Back" class="btn back-btn" /> 
        </div>
        <form v-on:submit.prevent="onSubmit">
          <div class="form-group">
            <label for="platform">Platform</label>
            <select name="platform" id="platform" v-model="platform">
              <option value="psn">Playstation</option>
              <option value="xbl">Xbox</option>
              <option value="battlenet">Battlenet</option>
            </select>
          </div>
          <div class="form-group">
            <label for="gamertag">Gamertag</label>
            <input
              type="text"
              name="text"
              v-model="gamertag"
              id="gamertag"
              placeholder="Battlenet gamertag, Xbox Live gamertag, PSN ID, etc"
            />
          </div>
          <div id="form-group">
            <input type="submit" value="Submit" class="btn" />
          </div>
        </form>
      </section>
    </div>
    <div v-else-if="this.$route.params.game === 'apex'">
      <img class='apex-logo logo-image' src="./../assets/apex/apexlogo.png" alt="apex=logo">
      <section class='search'>
        <div class='track-player-stats-container'>
          <h1>Track Player Stats</h1>
          <input v-on:click="goBackToMain" type="button" value="Back" class="btn back-btn" />
        </div>
        <form v-on:submit.prevent="onSubmit">
          <div class="form-group">
            <label for="platform">Platform</label>
            <select name="platform" id="platform" v-model="platform">
              <option value="psn">Playstation</option>
              <option value="xbl">Xbox</option>
              <option value="battlenet">Battlenet</option>
            </select>
          </div>
          <div class="form-group">
            <label for="gamertag">Gamertag</label>
            <input
              type="text"
              name="text"
              v-model="gamertag"
              id="gamertag"
              placeholder="Battlenet gamertag, Xbox Live gamertag, PSN ID, etc"
            />
          </div>
          <div id="form-group">
            <input type="submit" value="Submit" class="btn" />
          </div>
        </form>
      </section>
    </div>
    <div v-else-if="this.$route.params.game === 'csgo'">
      <img class='csgo-logo logo-image' src="./../assets/csgo/csgologo.png" alt="csgologo">
      <section class='search'>
        <div class='track-player-stats-container'>
          <h1>Track Player Stats</h1>
          <input v-on:click="goBackToMain" type="button" value="Back" class="btn back-btn" />
        </div>
        <form v-on:submit.prevent="onSubmit">
          <div class="form-group">
            <label for="steam">Platform</label>
            <select name="steam" id="steam" v-model="steam">
              <option value="steam">Steam</option>
            </select>
          </div>
          <div class="form-group">
            <label for="gamertag">Gamertag</label>
            <input
              type="text"
              name="text"
              v-model="gamertag"
              id="gamertag"
              placeholder="Steam ID, Steam Community URL or Steam Vanity Username"
            />
          </div>
          <div id="form-group">
            <input type="submit" value="Submit" class="btn" />
          </div>
        </form>
      </section>
    </div>
    <div class='not-found' v-else>
      <h2>404 Not Found</h2>
      <input v-on:click="goBackToMain" type="button" value="Back" class="btn back-btn" />
    </div>
  </section>
</template>

<script>
import NotFound from './NotFound'
export default {
  name: "Search",
  data() {
    return {
      game: '',
      platform: "psn",
      steam: "steam",
      gamertag: ""
    };
  },
  beforeCreate() {

  },
  methods: {
    onSubmit() {
      if (!this.gamertag) {
        this.$toasted.show("Please enter a gamertag", {
          duration: 3000,
          icon: "exclamation-circle"
        });
      } else if (this.$route.params.game === 'csgo'){
        this.$router.push(`/${this.$route.params.game}/profile/${this.steam}/${this.gamertag}`);
      } else {
        this.$router.push(`/${this.$route.params.game}/profile/${this.platform}/${this.gamertag}`);
      }
    },
    goBackToMain() {
      document.body.className = "bg-no-image"; 
      this.$router.push('/');
      this.$router.go();
    },
    getClass(){
      if(this.$route.params.game === 'overwatch'){
        document.body.className = "body-bg-overwatch";        
        return 'bg-overwatch background';
      } else if (this.$route.params.game === 'apex'){
        document.body.className = "body-bg-apex";        
        return 'bg-apex background';
      } else if (this.$route.params.game === 'csgo'){
        return 'bg-csgo background';
      } else return 'bg-no-image'
    }
  }
};
</script>

<style>
:root {
  --primary-color: #fff1ff;
}
body {
  background: var(--primary-color);
  font-family: Arial, Helvetica, sans-serif;
  color: #000;
  line-height: 1.6;
}
.bg-no-image {
  background: var(--primary-color);
}
.bg-overwatch {
  background: rgb(191, 210, 255) url("./../assets/overwatch/ashe.png") no-repeat top center;
  background-size: 60%;
}
.body-bg-overwatch {
  background: rgb(191, 210, 255);
}

.bg-apex {
  background: #953036 url("./../assets/apex/apexbackground.png") no-repeat top center;
  background-size: 60%;
}
.body-bg-apex {
  background: #953036
}

.bg-csgo {
  background: url("./../assets/csgo/csgobackground.png") no-repeat top center;
  background-size: 85%;
}
.background {
  width: 100%;
  height: 100%;
}

.logo-image {
  width: 15%;
  margin-top: 0.4rem;
  margin-left: 1rem;
}
.csgo-logo {
  margin: 1.3rem;
  margin-bottom: 3rem;
}

.overwatch-logo {
  margin-top: 1.2rem;
  margin-left: 0.6rem;
}

.track-player-stats-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.back-btn {
  background: rgb(74, 0, 106);
  color: white;
  transition: all .2s ease-in-out;
  font-weight: lighter;
  width: 8rem;
}
.back-btn:hover {
  background:rgb(39, 1, 57);
}
.not-found{
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>